// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumerToastBar-module_toastBar__WvXPf {
    left: 0;
    position: fixed;
    right: 0;
    top: 24px;
    pointer-events: none;
    z-index: var(--zindex-toast);
}

.consumerToastBar-module_toastBarInner__YTtNU {
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;
}

.consumerToastBar-module_toastBarContent__FuRHZ {
    align-items: center;
    color: var(--white, #FFFFFF);
    background-color: var(--black, #000000);
    border-radius: 12px;
    box-shadow: var(--shadow-float-secondary);
    display: flex;
    gap: 10px;
    padding: 16px;
    pointer-events: initial;
    cursor: pointer;
}

.consumerToastBar-module_toastBarIcon__YUNZt {
    display: flex;
    flex: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/common/ToastBar/consumerToastBar.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,eAAe;IACf,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,uCAAuC;IACvC,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;AACd","sourcesContent":[".toastBar {\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 24px;\n    pointer-events: none;\n    z-index: var(--zindex-toast);\n}\n\n.toastBarInner {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 432px;\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n.toastBarContent {\n    align-items: center;\n    color: var(--white, #FFFFFF);\n    background-color: var(--black, #000000);\n    border-radius: 12px;\n    box-shadow: var(--shadow-float-secondary);\n    display: flex;\n    gap: 10px;\n    padding: 16px;\n    pointer-events: initial;\n    cursor: pointer;\n}\n\n.toastBarIcon {\n    display: flex;\n    flex: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toastBar": `consumerToastBar-module_toastBar__WvXPf`,
	"toastBarInner": `consumerToastBar-module_toastBarInner__YTtNU`,
	"toastBarContent": `consumerToastBar-module_toastBarContent__FuRHZ`,
	"toastBarIcon": `consumerToastBar-module_toastBarIcon__YUNZt`
};
export default ___CSS_LOADER_EXPORT___;
